/**
 * routes/RequirePermission.jsx -- Port de canAccessModule() +
 * isProfileIncompatible() en src/js/route-guard.js.
 *
 * En el original, shell.js llama a estas 2 funciones DENTRO de
 * routeFromHash() antes de decidir que mostrar (un "if" mas en medio de
 * un router hecho a mano). Aqui es un componente que ENVUELVE la ruta
 * -- react-router-dom no necesita que reinventes el listener de
 * hashchange ni el "hideAllScreens()"; eso ya lo hace el propio Router
 * al desmontar la ruta anterior y montar la nueva.
 *
 * Mismo principio de doc 22/25 tal cual: esto SOLO es la segunda capa
 * de defensa (UI). La barrera real sigue siendo el backend rechazando
 * la peticion -- ningun framework de frontend cambia esa regla.
 */
import { useSession } from '../state/useSession.js';
import DeniedScreen from './DeniedScreen.jsx';

export default function RequirePermission({ moduleDef, children }) {
  const { session, can } = useSession();

  if (moduleDef.incompatibleWith?.includes(session.perfil)) {
    return <DeniedScreen variant="incompatible" moduleTitle={moduleDef.title} />;
  }
  if (!can(moduleDef.permiso)) {
    return <DeniedScreen variant="denied" moduleTitle={moduleDef.title} />;
  }
  return children;
}
